export const Logo = ({ tone = "dark", compact = false }) => (
  <span className="flex items-center gap-3" data-testid="oris-logo">
    <img
      src="/assets/oris-mark.png"
      alt="Emblème ORIS INTERNATIONAL"
      className={`${
        compact ? "h-12 w-12" : "h-14 w-14"
      } rounded-full bg-white object-contain p-[3px] ring-1 ring-oris-green/15`}
    />
    <span className="flex flex-col leading-none">
      <span
        className={`font-serif text-[1.7rem] font-semibold tracking-[0.18em] ${
          tone === "dark" ? "text-oris-green" : "text-oris-cream"
        }`}
      >
        ORIS
      </span>
      <span
        className={`text-[0.58rem] font-semibold uppercase tracking-[0.42em] ${
          tone === "dark" ? "text-oris-moss" : "text-oris-gold"
        }`}
      >
        International
      </span>
    </span>
  </span>
);

export const LogoFull = ({ className = "w-56" }) => (
  <span data-testid="oris-logo-full" className="inline-block border border-oris-cream/15 bg-white p-4">
    <img src="/assets/oris-wordmark.png" alt="ORIS INTERNATIONAL — Import · Export" className={className} />
  </span>
);
